import React from 'react';
import styled from 'styled-components';
import Grid from '@ntuctech/devex-tangram/Grid';
import Input from '@ntuctech/devex-tangram/Input';

import { Typography } from '@ntuctech/devex-tangram';
import { SCREEN_SIZE } from '../../../lib/mediaQuery';

export const WhiteBox = styled.div`
  background-color: #fff;
  padding: 2rem;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  border: 1px solid #eaeaea;

  .no-spacing {
    padding: 0 !important;
    margin: 0 !important;
  }
  ${SCREEN_SIZE.Only.Tablet} {
    padding: 1.5rem !important;
  }
  ${SCREEN_SIZE.Below.MobileL} {
    padding: 1rem !important;
    border-radius: 0;
    border: 0;
  }
`;

export const RmvInnerPad = styled.div`
  padding: 0;
  margin: 0;
  .no-margin {
    > p {
      margin: 0;
    }
  }
  .margin-bottom-24 {
    margin-bottom: 1.5rem !important;
  }
`;

const BoxTitle = styled.h5`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #333333;
  margin: 0;
`;

const TextAreaSection = styled.div`
  max-width: 540px;
  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
  > div {
    margin-bottom: 0;
    width: 100%;
  }
  > div div {
    width: 100%;
  }
  > div div:nth-child(1) {
    position: relative;
  }
`;

const AddMessage = (props) => {
  const { voucherData, setVoucherData, setManuallymsg, counterInputRef, isB2bEnabled } = props;
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const updateWindowDimensions = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', updateWindowDimensions);

    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  return (
    <WhiteBox isB2bUser={isB2bEnabled}>
      <RmvInnerPad>
        <Grid container className="no-spacing">
          <Grid item xs={12} className="no-spacing">
            <BoxTitle>
              <Typography variant="titleS">Add message</Typography>
            </BoxTitle>
            <Grid className="no-spacing margin-bottom-24">
              <Typography variant="bodyM">
                {isMobile || isB2bEnabled
                  ? 'Your recipients will see this message with their E-Gift Vouchers.'
                  : 'Preview your customised voucher in the right panel.'}
              </Typography>
            </Grid>
            <TextAreaSection>
              <Input
                data-testid="message"
                as="textarea"
                id="message"
                helpText={`${
                  (voucherData.metadata.message && voucherData.metadata.message.length) || 0
                }/500`}
                name="Message"
                tabindex="0"
                isMasked
                label="Your message"
                inputRef
                rows={4}
                cols={30}
                value={voucherData.metadata.message}
                ref={counterInputRef}
                onChange={(event) => {
                  if (event.target.value.length <= 500) {
                    setVoucherData({
                      ...voucherData,
                      metadata: {
                        ...voucherData.metadata,
                        message: event.target.value,
                      },
                    });
                  }
                  setManuallymsg(true);
                }}
              />
            </TextAreaSection>
          </Grid>
        </Grid>
      </RmvInnerPad>
    </WhiteBox>
  );
};

export default AddMessage;
